export class Outbound {
    downloadAktiv = false;
    emailAktiv = false;
}
